import { each } from "underscore";

export function getClone(variable) {
  // A function to deep clone a variable.
  // Supports basic variables, arrays, "dictionaries", and Maps as nested values
  let newVar = null;

  // Special handling for more complicated types
  if (variable instanceof Map) {
    newVar = new Map();
    for (let [mapKey, mapValue] of variable) {
      newVar.set(mapKey, getClone(mapValue));
    }
  } else if (variable instanceof Array) {
    newVar = [];
    for (let i = 0; i < variable.length; ++i) {
      newVar.push(getClone(variable[i]));
    }
  } else if (variable instanceof Function) {
    // Don't bother supporting functions yet
    throw new Error("Cloning a function not supported: " + variable);
  } else if (variable instanceof Object) {
    newVar = {};
    each(variable, (variable, key) => {
      newVar[key] = getClone(variable);
    });
  } else {
    // Booleans, strings, numbers, etc.
    // By default just set the value blindly
    newVar = variable;
  }
  return newVar;
}

export function mergeDictIntoMap(map, dict) {
  // A function that takes a map and a dictionary as argument, and uses the values from the
  // dictionary to set values that match the same structure in the (potentially deeply-nested) map
  // object; for example:
  //
  // Map:
  //   array
  //   Map
  //     Map
  //     array
  //     object
  //   object
  //
  // Note that this function _does not_ support a Map nested inside an object, like this:
  //
  // Map:
  //   object
  //     Map

  // Loop through the given dictionary
  each(dict, (dictValue, dictKey) => {
    // If the map's value is itself another map
    if (map.get(dictKey) instanceof Map) {
      // Recursively merge the dictionary into the map
      mergeDictIntoMap(map.get(dictKey), dictValue);
    } else {
      map.set(dictKey, dictValue);
    }
  });
}

export function convertMapToDict(map) {
  // Given a map object, returns a dictionary with the same structure and values
  // We do this for easier serialization to the backend, as Javascript Maps, specifically
  // deeply-nested ones, aren't handled nicely by JSON functions
  //
  // Note that this function _does not_ support a Map nested inside an object
  let dict = {};
  for (let [key, value] of map) {
    // If we have a deeply-nested Map
    if (value instanceof Map) {
      dict[key] = convertMapToDict(value);
    } else {
      dict[key] = value;
    }
  }
  return dict;
}

export function scrollToResultsTop() {
  const results = document.getElementsByClassName("search-results")[0];
  const resultsRect = results.getBoundingClientRect();

  if (results.scrollTo !== undefined) {
    // Scroll the results div
    results.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    // Scroll the whole window (mobile)
    window.scrollTo(
      window.scrollX + resultsRect.x,
      window.scrollY + resultsRect.y - 75
    );
  } else {
    results.scrollTop = 0;
  }
}
